import {fromJS} from 'immutable'

import {
  SET_CHAT_LIST_USER,
  REMOVE_CHAT_LIST_USER,
  SET_CHAT_LIST_GUESTS
} from '../action_types'

export default (state = fromJS({count: 0}), action) => {
  let count

  switch (action.type) {
    case SET_CHAT_LIST_USER:
      count = state.get('count', 0) + 1

      return state.set('count', count)

    case REMOVE_CHAT_LIST_USER:
      count = state.get('count', 0) - 1
      if (count < 0) count = 0

      return state.set('count', count)

    case SET_CHAT_LIST_GUESTS:
      count = state.get('count', 0) + action.guests.size

      return state.set('count', count)

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/chat_list_count.js
 **/